import { render, staticRenderFns } from "./AggregateReport.vue?vue&type=template&id=b827e066"
import script from "./AggregateReport.vue?vue&type=script&lang=js"
export * from "./AggregateReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports